import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "searchInput"]
  static values = { 
    expanded: { type: Boolean, default: false },
    matchingCount: { type: Number, default: 0 },
    nonMatchingCount: { type: Number, default: 0 },
    totalCount: { type: Number, default: 0 }
  }

  connect() {
    this.filterCodes() // Initial filter to setup visibility
  }

  preventClose(event) {
    // Prevent clicks on search input from closing the accordion
    event.stopPropagation()
  }

  handleKeydown(event) {
    if (event.key === 'Escape' && this.hasSearchInputTarget) {
      this.searchInputTarget.value = ''
      this.filterCodes()
    }
  }

  badgeToggle(event) {
    // Prevent event from bubbling up to the main toggle
    event.stopPropagation()
    // Call the main toggle method
    this.toggle()
  }

  toggle() {
    this.expandedValue = !this.expandedValue
    this.element.classList.toggle('expanded', this.expandedValue)
    
    // Focus search input when expanding
    if (this.expandedValue && this.hasSearchInputTarget) {
      setTimeout(() => {
        this.searchInputTarget.focus()
      }, 100)
    }
    
    // Clear search when collapsing
    if (!this.expandedValue && this.hasSearchInputTarget) {
      this.searchInputTarget.value = ''
      this.filterCodes()
    }

    this.updateAlternatingRows()
  }

  filterCodes() {
    if (!this.hasSearchInputTarget) return

    const searchTerm = this.searchInputTarget.value.toLowerCase().trim()
    const codeElements = this.element.querySelectorAll('[data-option-code]')
    
    let visibleMatchingCount = 0
    let visibleNonMatchingCount = 0

    codeElements.forEach(codeElement => {
      const codeText = codeElement.dataset.optionCode.toLowerCase()
      const shouldShow = searchTerm === '' || codeText.includes(searchTerm)
      
      codeElement.style.display = shouldShow ? '' : 'none'
      
      if (shouldShow) {
        const isMatching = codeElement.classList.contains('matching-code')
        if (isMatching) {
          visibleMatchingCount++
        } else {
          visibleNonMatchingCount++
        }
      }
    })

    // Update section visibility and counts
    this.updateSectionVisibility(visibleMatchingCount, visibleNonMatchingCount)
    this.updateVisibleCounts(visibleMatchingCount, visibleNonMatchingCount, searchTerm)
  }

  updateSectionVisibility(visibleMatching, visibleNonMatching) {
    // Handle shared codes section
    const sharedSection = this.element.querySelector('.shared-codes-section')
    if (sharedSection) {
      sharedSection.style.display = visibleMatching > 0 ? '' : 'none'
    }
    
    // Handle vehicle unique sections
    const vehicle1Section = this.element.querySelector('.vehicle-unique-section:has(.text-primary)')
    const vehicle2Section = this.element.querySelector('.vehicle-unique-section:has(.text-info)')
    
    if (vehicle1Section) {
      const vehicle1Codes = vehicle1Section.querySelectorAll('[data-option-code]:not([style*="display: none"])')
      vehicle1Section.style.display = vehicle1Codes.length > 0 ? '' : 'none'
    }
    
    if (vehicle2Section) {
      const vehicle2Codes = vehicle2Section.querySelectorAll('[data-option-code]:not([style*="display: none"])')
      vehicle2Section.style.display = vehicle2Codes.length > 0 ? '' : 'none'
    }
  }

  updateVisibleCounts(visibleMatching, visibleNonMatching, searchTerm) {
    // Update shared codes count
    const sharedHeader = this.element.querySelector('.shared-codes-section .code-count')
    if (sharedHeader) {
      if (searchTerm) {
        sharedHeader.textContent = `(${visibleMatching} of ${this.matchingCountValue})`
      } else {
        sharedHeader.textContent = `(${this.matchingCountValue})`
      }
    }
    
    // Update vehicle-specific counts
    const vehicle1Header = this.element.querySelector('.vehicle-unique-section:has(.text-primary) .code-count')
    const vehicle2Header = this.element.querySelector('.vehicle-unique-section:has(.text-info) .code-count')
    
    if (vehicle1Header) {
      const vehicle1Visible = this.element.querySelectorAll('.vehicle-1-only:not([style*="display: none"])').length
      const vehicle1Total = this.element.querySelectorAll('.vehicle-1-only').length
      if (searchTerm) {
        vehicle1Header.textContent = `(${vehicle1Visible} of ${vehicle1Total})`
      } else {
        vehicle1Header.textContent = `(${vehicle1Total})`
      }
    }
    
    if (vehicle2Header) {
      const vehicle2Visible = this.element.querySelectorAll('.vehicle-2-only:not([style*="display: none"])').length
      const vehicle2Total = this.element.querySelectorAll('.vehicle-2-only').length
      if (searchTerm) {
        vehicle2Header.textContent = `(${vehicle2Visible} of ${vehicle2Total})`
      } else {
        vehicle2Header.textContent = `(${vehicle2Total})`
      }
    }
  }

  updateAlternatingRows() {
    // Re-apply alternating row colors similar to accordion_controller
    const visibleRows = document.querySelectorAll("li.header-result:not([style*='display: none'])")
    
    visibleRows.forEach(row => row.classList.remove('row-even'))
    
    visibleRows.forEach((row, index) => {
      if (index % 2 === 0) {
        row.classList.add('row-even')
      }
    })
  }


}
